import React from 'react'
import { Box, Button, Flex, Image, Text } from '@chakra-ui/react'
import { navigate } from 'gatsby'

import { ActionItemFieldsFragment } from '~graphql/generated/graphql'
import { formatHumanReadableDate } from '~components/chats/chat/messages-list/message-content/message-helpers'
import { UserRoutes } from '~config/routes'

export default function PetSelfieContent({
    actionItem,
}: {
    actionItem: ActionItemFieldsFragment
}) {
    const selfie = actionItem.pet_selfie
    if (!selfie) return null

    const petName =
        selfie.pet_name?.trim() || selfie.patient?.name?.trim() || 'a pet'
    const imageUrl = selfie.display_media_url || selfie.submitted_media_url

    return (
        <Box w="full">
            <Flex
                mt={1}
                justify="space-between"
                alignItems="center"
                direction="row"
                gap={3}
            >
                <Flex alignItems="center" gap={3} minW={0}>
                    <Image
                        src={imageUrl}
                        alt={petName}
                        boxSize="48px"
                        objectFit="cover"
                        rounded="md"
                        flexShrink={0}
                    />
                    <Box minW={0}>
                        <Text fontWeight="semibold" noOfLines={1}>
                            Pet selfie submitted for {petName}
                        </Text>
                        <Text fontSize="sm" color="gray.600" noOfLines={1}>
                            {selfie.display_caption || 'No caption'} —{' '}
                            {formatHumanReadableDate(
                                actionItem.created_at || 0,
                            )}
                        </Text>
                    </Box>
                </Flex>
                <Button
                    size="xs"
                    shadow="sm"
                    colorScheme="brand"
                    onClick={() => navigate(UserRoutes.PetSelfies)}
                >
                    Review
                </Button>
            </Flex>
        </Box>
    )
}
